<template>
  <div class="l-home-container l-container">
    <LHeader />
    <Lbubbles />
    <section class="l-wen-wu-szg-section">
      <!-- 文 -->

      <div class="wen">
        <img src="./images/wen/bg.png" class="bg" />
        <img src="./images/dot/flag.gif" alt class="flag" />
        <img src="./images/wen/stone101.png" class="stone101" />
        <img src="./images/dot/shanhu3.png" class="shanhu3 stone-and-plan" />
        <img src="./images/dot/shanhu-tree3.png" class="shanhu-tree3 stone-and-plan" />
        <!-- <img class="lock" v-if="!havYueLesson" src="./images/lock/lock.png" @click="onGoTo(101)" /> -->
        <img class="start" src="./images/lock/start.png" @click="onGoTo(101)" />
        <div class="pulse pulse-wen"></div>
      </div>
      <!-- 武 -->
      <div class="wu">
        <img src="./images/wu/star.png" class="stone-and-plan l-wu-star" />
        <img src="./images/wu/bg.png" class="bg" />
        <img src="./images/szg/stone103.png" class="stone102" />
        <img src="./images/dot/shanhu-tree1.png" class="shanhu-tree1 stone-and-plan" />
        <img src="./images/dot/shanhu-tree2.png" class="shanhu-tree2 stone-and-plan" />
        <!-- <img class="lock" v-if="!havYuLesson" src="./images/lock/lock.png" @click="onGoTo(100)" /> -->
        <img class="start" src="./images/lock/start.png" @click="onGoTo(100)" />
        <div class="pulse"></div>
      </div>

      <!-- 水族馆 -->
      <div class="szg">
        <img src="./images/szg/bg.png" class="bg" />
        <img src="./images/dot/shanhu-tree2.png" class="shanhu-tree4 stone-and-plan" />
        <img src="./images/szg/stone103.png" class="stone103" />
        <!-- <img class="start" src="./images/lock/start.png" @click="onGoToAquarium()" /> -->
        <img src="./images/dot/shanhu1.png" class="shanhu1 stone-and-plan" />
        <img src="./images/szg/fish.gif" class="fish-gif stone-and-plan" />
        <div class="pulse pulse-szg"></div>
      </div>
    </section>

    <!-- 水草，珊瑚，石头等海洋植物,按照展示顺序排列 -->
    <img src="./images/dot/stone9.png" class="stone9 stone-and-plan" />
    <img src="./images/dot/shuicao2.gif" class="shuicao2 shuicao stone-and-plan" />
    <img src="./images/dot/shuicao2.gif" class="shuicao201 shuicao stone-and-plan" />
    <img src="./images/dot/stone7.png" class="stone7 stone-and-plan" />
    <img src="./images/dot/shanhu2.png" class="shanhu2 stone-and-plan" />
    <img src="./images/dot/stone2.png" class="stone2 stone-and-plan" />

    <img src="./images/dot/shuicao2.gif" class="shuicao202 shuicao stone-and-plan" />
    <img src="./images/dot/stone4.png" class="stone4 stone-and-plan" />
    <img src="./images/dot/stone8.png" class="stone8 stone-and-plan" />
    <img src="./images/dot/stone6.png" class="stone6 stone-and-plan" />

    <article class="stone-plan-composition">
      <img src="./images/dot/stone1.png" class="stone1" />
      <img src="./images/dot/stone104.png" class="stone104" />
    </article>

    <img src="./images/dot/shuicao3.gif" class="shuicao3 shuicao stone-and-plan" />
    <img src="./images/dot/shuicao2.gif" class="shuicao203 shuicao stone-and-plan" />
    <img src="./images/dot/shuicao2.gif" class="shuicao204 shuicao stone-and-plan-fix" />
    <img src="./images/dot/stone3.png" class="stone3 stone-and-plan-fix" />
    <img src="./images/dot/stone2.png" class="stone202 stone-and-plan-fix" />
    <img src="./images/dot/stone5.png" class="stone5 stone-and-plan-fix" />
    <img src="./images/dot/shuicao1.gif" class="shuicao1 stone-and-plan-fix" />
    <img src="./images/dot/flower.png" class="flower1 stone-and-plan-fix" />
    <img src="./images/dot/stone11.png" class="stone11 stone-and-plan" />
    <!-- 排行榜/成就 -->
    <article class="l-rank-achievement-article">
      <img src="./images/dot/achievementIcon.png" class="l-rank-achi-icon" @click="onGoAchievement" />
      <img v-if="isAchievementTips" src="./images/show/achievement-show.png" class="l-rank-achi-show" alt />
      <!-- <img src="./images/dot/rankIcon.png"
      class="l-rank-achi-icon">-->
    </article>
    <!-- LILY币商城 -->
    <article class="l-rank-mall-article">
      <img src="./images/dot/icon-mall.png" class="l-rank-mall-icon" @click="onGoMall" />
    </article>
    <!-- 战队信息 -->
    <article class="l-rank-team-article">
      <img src="./images/dot/icon-team.png" class="l-rank-team-icon" @click="onGoTeam" />
    </article>
    <div v-if="isNewReMake" class="l-user-remake">
      <div class="l-user-remake-show"></div>
      <img @click="onGoUserRemake" src="./images/remake/remark.png" />
    </div>
    <footer class="l-home-article" v-if="tribeFlag">
      <img :src="homeImage" class="l-home-article-icon" @click="onGoUserCenter" />
    </footer>
        
    <DialogAddress
        :visible.sync="needConfirmAddress"
        :form="addressInfo"
        @confirm="confirmAddress">
    </DialogAddress>
  </div>
</template>

<script>
import LHeader from '../layout/header'
import Lbubbles from './components/l-bubbles'
import DialogAddress from './components/dialog-address'
// import StudyModel from "@/models/study";
import UsercenterModel from '@/models/usercenter'
import ClasscoreModel from '@/models/classcore'
import { createNamespacedHelpers } from 'vuex'
import version from '@/utils/version'
import { goPage } from '@/utils/bridge'

const usercenterModel = new UsercenterModel()
// const studyModel = new StudyModel();
const classcoreModel = new ClasscoreModel()
const { mapMutations, mapGetters } = createNamespacedHelpers('course')
export default {
  name: 'l-home',
  data() {
    return {
      homeImage: require('@/assets/images/home.png'),
      tribeFlag: version.isLILYTribeAPP(), // 内嵌标识符
      havYuLesson: 0,
      havYueLesson: 0,
      isAchievementTips: false,
      isNewReMake: false,
      needConfirmAddress: false,
      addressInfo: {},
    }
  },
  components: {
    LHeader,
    Lbubbles,
    DialogAddress,
  },
  computed: {
    ...mapGetters(['lesson']),
  },
  methods: {
    ...mapMutations(['SET_CURRENT_LESSON']),
    onGoUserCenter() {
      goPage(goPage.PageName.USERCENTER)
    },
    onGoTo(type) {
      let temp = this.lesson ? this.lesson : {}
      localStorage.setItem('stage', type)
      temp.stage = type
      this.SET_CURRENT_LESSON(temp)
      this.$router.push(`/level?stage=${type}`)
    },
    onGoToAquarium() {
      usercenterModel
        .getTokenCode({
          token: JSON.parse(localStorage.getItem('USER')).token,
        })
        .then((ress) => {
          let defaultUrl = `https://${process.env.VUE_APP_ENV == 'prod'
            ? ''
            : process.env.VUE_APP_ENV + '-'
            }szg.dayuan1997.com?code=${ress.data}&redirect_uri=${decodeURI(
              window.location.origin
            )}`
          if (
            this.$route.query &&
            this.$route.query.redirect_uri &&
            this.$route.query.redirect_uri !== 'undefined'
          ) {
            let realUrl = new URL(decodeURI(this.$route.query.redirect_uri))
            let current = new URL(window.location.href)
            if (current.host === realUrl.host) {
              window.location.href = defaultUrl
            } else {
              realUrl.searchParams.delete('code')
              realUrl.searchParams.set('code', ress.data)
              window.location.href = `${realUrl.href}&redirect_uri=${decodeURI(
                window.location.origin
              )}`
            }
          } else {
            window.location.href = `${defaultUrl}`
          }
        })
    },
    // getLessonStatus() {
    //     studyModel.getLessonStatus().then((res) => {
    //         this.havYuLesson = res.data.havYuLesson;
    //         this.havYueLesson = res.data.havYueLesson;
    //     });
    // },
    // 跳转赛季奖杯
    onGoAchievement() {
      this.$router.push('/achievement')
    },
    // 跳转LILY币商城
    onGoMall() {
      this.$router.push('/mall')
    },
    // 跳转到战队信息
    onGoTeam() {
      this.$router.push('/team-rank')
    },
    onIsFulfill() {
      // let list = []
      // classcoreModel
      //   .getMessageTips()
      //   .then((res) => {
      //     if (res.status == 0) {
      //       res.data.forEach((element) => {
      //         if (element.value == 1) {
      //           list.push(element)
      //         }
      //       })
      //       if (list.length > 0) {
      //         this.isAchievementTips = true
      //       } else {
      //         this.isAchievementTips = false
      //       }
      //     } else {
      //       this.isAchievementTips = false
      //     }
      //   })
      //   .catch(() => {
      //     this.isAchievementTips = false
      //   })
    },
    // //获取是否存在赛季末未读评语
    // onGetIsNewRamake() {
    //     classcoreModel.getUserTermMessage().then((res) => {
    //         if (res.status === 0) {
    //             this.isNewReMake = res.data
    //         }
    //     });
    // },
    // 跳转赛季末评语
    onGoUserRemake() {
      // this.$router.push({
      // 	path: `/newView`,
      // });
      this.$router.push({
        path: `/user?type=5`,
      })
    },
    // 检测是否有地址信息需要确认
    async checkAddress() {
      try {
        const res = await classcoreModel.needAddressConfirm()
        this.needConfirmAddress = res.data.needAddressConfirmation
        this.addressInfo = res.data
      } catch (error) {
        console.error(error)
      }
    },
    confirmAddress(params) {
      classcoreModel.updateAddress(params).then(() => {
        this.needConfirmAddress = false
      })
    },
  },
  created() {
    this.checkAddress()
  }
}
</script>

<style lang="stylus" scoped>
@import './home.styl'
</style>
